import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';


export default class GenerateSpace extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Generate Space
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/space/generate"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SpaceOperations/Components/GenerateSpace.js